module.exports = __webpack_public_path__ + "static/img/qrcode90.afb4082f.png";